import axios from "axios";

/**
 * Saves or updates blog author data via the API and updates parent with the resulting author_id.
 *
 * @param {number} id - The current author ID (0 for new author).
 * @param {Object} data - The author data to save.
 * @param {Function} setAuthorId - Callback to update the parent component with the new/used author_id.
 *
 * @example
 * saveAuthor(author_id, formData, onAuthorChange);
 */
export async function saveAuthor(id, data, setAuthorId) {
  const API_URL =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000/"
      : "https://api.hillerodfrimenighed.dk/";

  try {
    const res = await axios.post(`${API_URL}blog/author/${id}`, data, {
      withCredentials: true,
      headers: { "Content-Type": "application/json" },
    });

    // ✅ backend responds with { author_id: final_author_id }
    const newId = res?.data?.author_id;
    if (newId !== undefined) {
      setAuthorId(newId); // update parent/blog
    }

  } catch (error) {
    console.error("Save error:", error);
  }
}
